var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "nav-link d-flex align-items-end",
      attrs: {
        href: _vm.urlWishList,
        rel: "nofollow",
        "aria-label": _vm.$translate("Ceres::Template.wishList"),
      },
    },
    [
      _c("i", {
        staticClass: "fa",
        class: {
          "fa-heart fal": !_vm.wishListCount,
          "fa-heart": _vm.wishListCount,
        },
        attrs: { "aria-hidden": "true" },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "badge-right ml-1" }, [
        _vm._v(_vm._s(_vm.wishListCount)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }